import React from 'react';
import { usePageMeta } from '../hooks/usePageMeta';
import { PageHero } from '../components/ui/PageHero';
import { ButtonLink } from '../components/ui/ButtonLink';
import { TeamGrid } from '../components/team/TeamGrid';
import { Reveal } from '../components/motion/Reveal';
import { discussSearchHref } from '../data/navigation';
export function Team() {
  usePageMeta('Meet Our Search Executive Partners | Avenqor Talent Search', 'Meet the Search Executive Partners of Avenqor Talent Search, focused on executive search, professional talent sourcing and candidate engagement.');
  return <>
      <PageHero eyebrow="Our Team" title="Meet Our Search Executive Partners" intro="At Avenqor Talent Search, our team brings a focused approach to executive search, professional talent sourcing, and candidate engagement. We work to build meaningful connections between organizations and professionals whose expertise aligns with their strategic needs." data-id="element-564" data-mp="nhdy79vyzicb">
        <div className="flex flex-col gap-3 sm:flex-row" data-id="element-565" data-mp="2a5okjhxtkdu8">
          <ButtonLink to={discussSearchHref} variant="gold" data-id="element-566" data-mp="2a43sq02w3902">
            Discuss a Search
          </ButtonLink>
          <ButtonLink to="/services" variant="outlineLight" data-id="element-567" data-mp="2jw9qxrjqimnp">
            Explore Our Services
          </ButtonLink>
        </div>
      </PageHero>

      <section className="bg-paper" aria-labelledby="team-title" data-id="element-568" data-mp="2eyhq28143q7d">
        <div className="mx-auto max-w-7xl px-5 py-20 sm:px-8 lg:py-28" data-id="element-569" data-mp="1r72ls9pryyth">
          <h2 id="team-title" className="sr-only" data-id="element-570" data-mp="1r9f8t1ae3zde">
            Search Executive Partners
          </h2>
          <TeamGrid data-id="element-571" data-mp="208agyiwzvjjc" />
        </div>
      </section>

      <section className="bg-white" aria-labelledby="team-contact-title" data-id="element-572" data-mp="209218xl55uub">
        <Reveal className="mx-auto flex max-w-7xl flex-col gap-8 px-5 py-20 sm:px-8 lg:flex-row lg:items-center lg:justify-between lg:py-24" data-id="element-573" data-mp="1w6fhzl2jdi8q">
          <div className="max-w-2xl" data-id="element-574" data-mp="3blmfqfdwdbyn">
            <h2 id="team-contact-title" className="font-serif text-[2.25rem] font-medium leading-[1.1] text-navy sm:text-[2.75rem]" data-id="element-575" data-mp="37m43s9420b7y">
              Begin a confidential conversation.
            </h2>
            <p className="mt-4 text-[17px] leading-relaxed text-muted" data-id="element-576" data-mp="298q4123k080g">
              Share your requirement through our inquiry forms and it will be directed to the appropriate Search
              Executive Partner.
            </p>
          </div>
          <div className="flex flex-col gap-3 sm:flex-row" data-id="element-577" data-mp="1lkfe2tzebsqy">
            <ButtonLink to="/employers" variant="navy" data-id="element-578" data-mp="1lm03k56uslhy">
              For Employers
            </ButtonLink>
            <ButtonLink to="/candidates" variant="outlineDark" data-id="element-579" data-mp="1qjs0jdmcuxt0">
              For Candidates
            </ButtonLink>
          </div>
        </Reveal>
      </section>
    </>;
}